export const quotidienne = {
  forecast: {
    fiche: {
      titles: {
        edit_title: 'Fiche de la prévision {{code}}',
        new_title: "Création d'une nouvelle prévision",
        view_title: 'Fiche du format {{code}}',
        general: 'Général',
        characteristics: 'Caractéristiques',
        date_management: 'Gestion date',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
        reconciliation: 'Rapprochement',
        realization: 'Forcer la réalisation',
      },
      champ_titles: {
        account: 'Compte',
        label: 'Libellé',
        nature: 'Nature',
        amount: 'Montant {{type}}',
        op_date: 'Date opération',
        value_date: 'Date valeur',
        category: 'Catégorie',
        num_entry: 'Num. Ecriture',
        exo: 'Exonéré de commission de mouvement',
        type: 'Type',
        state: 'Etat',
        first_due: 'Première écheance',
        last_due: 'Dernière échéance',
        next_due: 'Date prochaine échéance',
        sequence: 'Périodicité',
        in_progress: 'Nb de prévisions en cours',
        change: 'débit ou crédit',
      },
      realization: {
        title: 'Fiche Prévision',
        message:
          'Etes-vous sûr de vouloir forcer la réalisation de la prévision',
      },
      rapprochement: {
        title: 'Rapprochement de trésorerie',
      },
      modal: {
        title: 'Rapprochement de trésorerie',
        rappro_prev: 'Prévisions rapprochées',
        rappro_mvt: 'Mouvements rapprochés',
        num_mvt: 'Nombre de mouvements',
        num_prev: 'Nombre de prévisions',
        amount_mvt: 'Montant des mouvements',
        amount_prev: 'Montant des prévisions',
        user: 'Utilisateur',
        date: 'Date',
        number: 'N° de rapprochement',
        title_user: 'Audit',
        creation_date: 'Date Création',
        user_creation: 'User Création',
        date_modification: 'Date Modification',
        user_modification: 'User Modifcation',
        columns: {
          label: 'Libellé',
          ref: 'Référence',
          category: 'Catégorie',
          ope_code: 'Code Opé',
          ope_date: 'Date Opé',
          value_date: 'Date valuer',
          amount: 'Montant',
          curr: 'Dev',
          exo: 'Exo',
          nature: 'Nature',
          entry_number: 'Num Ecriture',
        },
      },
    },
    table: {
      header: {
        title: 'Liste des prévisions',
        mass_update: 'Modification masse',
        prev_generation: 'Générer Prev. temporaire',
        prev_auto: 'Prévision automatique',
        import: 'Importer',
        more_action: 'Autre',
        generation: 'Génération des intradays',
        generation_title: 'Liste des intradays',
        generation_btn: 'Génération des prévisions',
      },
      columns: {
        state: 'Etat',
        account: 'Compte',
        label: 'Libelle',
        num_entries: 'N Ecriture',
        nature: 'Nature',
        category: 'Catégorie',
        exo: 'Exo',
        op_date: "Date d'opération",
        value_date: 'Date de valeur',
        amount: 'Montant',
        currency: 'Devise',
        type: 'Type',
        origin: 'Origine',
        user: 'User',
        update: 'Date de modification',
        creation: 'Création',
        ref: 'Référence',
        id_source: 'ID Fichier Source',
      },
      mass_update: {
        title: 'Modification en masse des prévisions',
        nature: 'Nature',
        type: 'Type',
        value_date: 'Date valeur',
        t2a: 'Passer les prévisions temporaires en active',
        d2a: 'Passer les prévisions supprimées en active',
        all2d: 'Passer les prévisions en état supprimée',
        j1_update: 'Modifier Valeur J+1',
        update: 'Valider',
        close: 'Annuler',
        category: 'Catégory',
      },
      import: {
        title: 'Import des prévisions',
        model: "Modèle d'import",
      },
    },
    automatic: {
      table: {
        header: {
          title: 'Liste des prévisions auto',
          new: 'Nouveau',
        },
        filters: {
          state: '-Etat-',
        },
        columns: {
          state: 'Etat',
          account: 'Code compte',
          label: 'Libellé',
          num_entries: 'N Ecriture',
          nature: 'Nature',
          category: 'Catégorie',
          exo: 'Exo',
          start_date: 'Date début',
          end_date: 'Date fin',
          next_due_date: 'Date échéance',
          amount: 'Montant',
          currency: 'Devise',
          type: 'Type',
          num_forecast: 'N° prévisions en cours',
          user: 'Utilisateur',
          update: 'Modification',
        },
      },
      fiche: {
        titles: {
          edit_title: 'Fiche prévision auto {{code}}',
          new_title: "Création d'une nouvelle prévision auto",
        },
        buttons: {
          generate: 'Générer les prévisions',
        },
        generation: {
          title: 'Génération prévisions',
          message: 'Voulez-vous Régénérer des prévisions',
        },
      },
    },
    temporary_prev_generation: {
      titles: {
        main_title: 'Gestion des prévisions temporaires',
        temporary_forecast: 'Prévisions temporaires',
        forecast_to_keep: 'Prévisions à garder',
        active_forecast: 'Prévisions actives',
        edit_modal: 'Modification Prévisions à garder',
      },
      champ_titles: {
        type: 'Type',
        value_date: 'Date Valeur',
        label: 'Libelle',
      },
      buttons: {
        generate: 'Générer',
      },
      modal: {
        title: 'Liste des prévisions',
        message:
          "Voulez-vous passer en actif toutes les prévisions temporaires n'ayant pas de prévisions actives comparables",
      },
    },
  },

  cashpooling: {
    title: {
      general: 'Cashpooling',
      position_value: 'Positions en Valeur',
      flow_proposal: 'Propositions de flux de trésorerie',
      remove: 'Voulez-vous supprimer le flux',
    },
    select_grp_compte_cashpooling: 'Groupe de compte de cash-pooling',
    select_grp_compte_parametrage: 'Groupe de compte de paramétrage',
    flow_list_placeholder: '-Flux trésorerie par défaut-',
    buttons: {
      validate: 'Valider les propositions',
      new: 'Nouveau',
    },
    columns: {
      account: 'Compte',
      balance: 'Solde Avant',
      balance_after: 'Solde Après',
      value_date: 'Date',
      authorized: 'Autorisé',
      currency: 'Devise',
      date: 'Date',
      amount: 'Montant',
      credit_account: 'Compte crédité',
      debit_account: 'Compte débité',
    },
    modal: {
      title: {
        new_flow: "Création d'un nouveau flux de trésorerie",
        edit_flow: "Modification d'un flux de trésorerie",
      },
      buttons: {
        add: 'Valider',
        close: 'Annuler',
      },
      placeholder: {
        nature: '- Nature -',
        label: 'Libellé automatique si vide',
      },
      champ_titles: {
        debit_account: 'Compte débité',
        credit_account: 'Compte crédité',
        label: 'Libellé',
        current_account: 'Compte courant',
        debit_nature: 'Nature Débit',
        credit_nature: 'Nature Crédit',
        amount: 'Montant',
        value_date: 'Date Valeur',
        error_devise_compte:
          'Veillez selectionner les comptes de mêmes devise.',
      },
    },
  },

  historique: {
    title: {
      general: 'Historique de rapprochement de Trésorerie',
      bank_mvt: 'Mouvements bancaire rapprochés',
      prov: 'Prévisions rapprochées',
      // detail_mvt: 'Détail mouvement bancaire',
      detail_mvt: 'Rapprochement - Detail',
    },
    buttons: {
      show_details: 'Visualisation Détail',
      show_sessions: 'Visualisation Session',
    },
    filters: {
      account: 'Compte',
      rappro_date: 'Date Rapprochement',
      value_date: 'Date Valeur',
      group: 'Groupe',
    },
    columns: {
      account: 'Compte',
      category: 'Cat.',
      date: 'Date Val.',
      label: 'Libellé',
      amount: 'Montant',
    },
    alert: {
      rappro_session: "il n'y a pas de dérapprochement à réaliser",
    },
    modal: {
      title: {
        session_list: 'Liste des sessions',
      },
      columns: {
        date_num: 'Date/Num',
        user: 'User',
        value_date_movement: 'Date Mvt',
        value_date_prev: 'Date Prev',
        category: 'Cat.',
        nature: 'Nature',
        label: 'Libellé',
        amount: 'Montant',
        number: 'Nb',
        nb_mvt: 'Nb mouvement',
        nb_prevision: 'Nb prévision',
      },
      groups: {
        mvts: 'Mouvements à rapprocher',
        prevs: 'Prévisions à rapprocher',
      },
      buttons: {
        visualize: 'Visualiser',
        dereconciliation: 'Derapprocher',
      },
    },
  },

  research: {
    table: {
      header: {
        title: 'Liste des recherches',
        load_search: 'Lancer la recherche',
      },
      filters: {
        account_group: 'Groupes de comptes',
        account: 'Comptes',
        amount_min: 'De',
        amount_max: 'A',
      },
      columns: {
        state: 'Etat',
        account: 'Compte',
        label: 'Libelle',
        reference: 'Référence',
        nature: 'Nature',
        category: 'Catégorie',
        op_date: 'Date opé.',
        value_date: 'Date Valeur',
        amount: 'Montant',
        currency: 'Devise',
        type: 'Type',
        entry_number: 'Num Ecriture',
        nature_code: 'Code Nature',
        integration_date: "Date d'intégration",
      },
      ventilation: {
        title: 'Ventilation',
        nature: 'Nature',
        label: 'Libelle',
        amount: 'Montant',
        total: 'Total',
        gap: 'Ecart',
      },
      mass_update: {
        title: 'Modification en masse',
        message:
          'Souhaitez-vous modifier le code nature et/ou la catégorie des éléments sélectionnés ?',
      },
      visualisation: {
        headers: {
          detail: "Détail de l'opération",
          treasury_rappro: 'Rapprochement trésorerie',
          accounting_rappro: 'Rapprochement comptable',
        },
        columns: {
          compte: 'Compte',
        },
      },
    },
  },

  ventilation: {
    title: {
      general: 'Ventilation de Trésorerie',
    },
    buttons: {
      show_ventilate_manual: 'Ventilation Manuelle',
      show_ventilate_automatic: 'Ventilation Règles',
    },
    columns: {
      account: 'Compte',
      category: 'Catégorie',
      date: 'Date Valeur',
      label: 'Libellé',
      amount: 'Montant',
      compte: 'Compte',
      devise: 'Devise',
    },
    modal: {
      title: {
        general: 'Mouvements à ventiler',
        ventilate: '- Nature -',
        error_nature_not_selected: 'Veuillez choisir un code nature',
      },
      columns: {
        value_date_movement: 'Date Mvt',
        category: 'Cat.',
        nature: 'Nature',
        label: 'Libellé',
        amount: 'Montant',
        number: 'Nb',
      },
      buttons: {
        ventilate: 'Ventiler',
      },
    },
  },

  value: {
    title: {
      general: 'Visualisation de la fiche en valeur',
      state_items: 'Liste des états',
      unfold_nodes: 'Déplier tous les noeuds',
      search_items: 'Recherche',

      // position_value: 'Positions en Valeur',
      // flow_proposal: 'Propositions de flux de trésorerie',
      // remove: 'Voulez-vous supprimer le flux',
    },
    // select_grp_compte_cashpooling: 'Groupe de compte de cash-pooling',
    // select_grp_compte_parametrage: 'Groupe de compte de paramétrage',
    buttons: {
      // validate: 'Valider les propositions',
      // new: 'Nouveau',
      sheet_in_value: 'Fiche en Valeur',
    },
    columns: {
      groups: '-Groupes-',
      company: '- Société -',
      bank: '- Banque -',
      currency: '- Devise -',
      country: '- Pays -',
      state: '-Etats-',
    },
    modal: {
      title: {
        value_sheet: 'Fiche Valeur',
        details: 'Détail de la journée',
      },
      footer: {
        debit: 'Total débit',
        credit: 'Total crédit',
        daily: 'Total journée',
      },
    },
  },

  reconciliation: {
    headers: {
      title: 'Rapprochement de trésorerie',
      details: 'Rapprochement de trésorerie - Détail',
      accounts: 'Comptes',
      viewType: 'Vue',
    },
    inputs: {
      total_movements: 'Total Mouvements',
      gap: 'Ecart',
      total_forecasts: 'Total Prévisions',
      number: 'Nb',
      confirmTxt: 'Un écart existe. Validez-vous le rapprochement',
      confirmTitle: 'Rapprochement',
    },
    cards: {
      movements: 'Mouvements bancaires à rapprocher',
      rappro: 'Rapprochement',
      forecasts: 'Prévisions à rapprocher',
    },
    buttons: {
      manual: 'Lancer règles manuelles',
      next_account: 'Compte suivant',
      montant: 'Montant 1/1',
      montantNN: 'Montant N/N',
      reconcile: 'Rapprocher',
    },
    columns: {
      selected: 'Sel.',
      category: 'Catégorie',
      value_date: 'Date valeur',
      label: 'Libellé',
      amount: 'Montant',
      account: 'Compte',
      state: 'Etat',
      balanced: 'Equilibré',
      unbalanced: 'Non équilibré',
    },
    message: {
      all_treated: 'Tous les comptes ont été traités',
    },
  },
}

